import React, { useState, useEffect } from "react";
import { Upload, Button, message, Spin, Modal } from "antd";
import ImgCrop from "antd-img-crop";
import useAxiosInstance from "../../lib/useAxiosInstance";
import { toast, ToastContainer } from "react-toastify";

import profile from "../../assets/images/placeholder-icon.png";
import { useTranslation } from "react-i18next";

const ProfilePicUpload = ({ user }) => {
  const { t } = useTranslation();
  const axiosInstance = useAxiosInstance();
  const [fileList, setFileList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [imageSelected, setImageSelected] = useState(false);

  useEffect(() => {
    const fetchProfileImage = async () => {
      try {
        setLoading(true);
        const response = await axiosInstance.get(
          `api/clients/info/getProfileImage/${user?._id}`
        );
        const photoUrl = response?.data?.data?.profileImageLink?.publicUrl;

        setFileList([
          {
            uid: "-1",
            name: "image.png",
            status: "done",
            url: photoUrl || profile
          }
        ]);
      } catch (error) {
        console.error("Error fetching profile image:", error);
      } finally {
        setLoading(false); // Set loading to false after fetching data
      }
    };

    fetchProfileImage();
  }, []);

  const onChange = ({ fileList: newFileList }) => {
    setFileList(newFileList);
    setImageSelected(true);
  };

  // const onRemove = () => {
  //   setFileList([]);
  //   setImageSelected(false);
  // };

  const onRemove = () => {
    Modal.confirm({
      title: t("Are you sure you want to remove the photo?"),
      okText: t("Yes"),
      cancelText: t("No"),
      onOk: async () => {
        try {
          setLoading(true);
          await axiosInstance.delete(
            `api/clients/info/profile/${user?._id}`
          );
          setFileList([]);
          setImageSelected(false);
          toast.success("Profile image removed successfully", {
            onClose: () => {
              setTimeout(() => {
                window.location.reload();
              }, 1000);
            }
          });
        } catch (error) {
          console.error(error);
          toast.error("Error removing profile image");
        } finally {
          setLoading(false);
        }
      }
    });
  };

  const onPreview = async (file) => {
    const src = file.url;
    if (src && typeof src === "string") {
      const image = new Image();
      image.src = src;
      const imgWindow = window.open(src);
      imgWindow?.document.write(image.outerHTML);
    } else {
      message.error("Preview not available. Please save the photo first.");
    }
  };

  const handleSave = async () => {
    const selectedFile = fileList[0];
    if (selectedFile) {
      const formData = new FormData();
      formData.append("profileImageLink", selectedFile.originFileObj);
      try {
        setLoading(true);
        await axiosInstance.put(
          `api/clients/info/profile/${user?._id}`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data"
            }
          }
        );
        toast.success("Profile image uploaded successfully", {
          onClose: () => {
            setTimeout(() => {
              window.location.reload();
            }, 1000);
          }
        }); // Move the toast call here
      } catch (error) {
        console.error(error);
        toast.error("Error uploading profile image");
      } finally {
        setLoading(false); // Set loading to false after sending data
      }
    }
  };

  return (
    <div className='flex mb-10'>
      <ToastContainer />
      <div className='mt-5 ml-5'>
        <ImgCrop
          rotationSlider
          modalWidth={500}
          modalOk='Crop'
          modalProps={{
            okButtonProps: {
              className: "custom-ok-modal-button"
            },
            cancelButtonProps: { className: "custom-cancel-modal-button" }
          }}
        >
          <Upload
            listType='picture-card'
            fileList={fileList}
            onChange={onChange}
            onPreview={onPreview}
            beforeUpload={() => false}
          >
            {fileList.length < 1 && "+ Upload"}
          </Upload>
        </ImgCrop>
      </div>
      <div className='profile-pic-buttons'>
        <Spin spinning={loading}>
          <div>
            <Button
              className='upload-photo-btn primary-background'
              type='primary'
              onClick={handleSave}
              disabled={!imageSelected}
            >
              {t("Save Photo")}
            </Button>
          </div>
          <Button
            className='delete-photo-btn'
            type='primary'
            ghost
            onClick={onRemove}
          >
            {t("Remove Photo")}
          </Button>
        </Spin>
      </div>
    </div>
  );
};

export default ProfilePicUpload;
